export const diplomasActionTypes = {
    ADD_DIPLOMA: "ADD_DIPLOMA",
    REMOVE_DIPLOMA: "REMOVE_DIPLOMA",
    CHANGE_DIPLOMA: "CHANGE_DIPLOMA",
    MOVE_DIPLOMA_UP: "MOVE_DIPLOMA_UP",
    MOVE_DIPLOMA_DOWN: "MOVE_DIPLOMA_DOWN",
}

export function diplomasReducer( diplomas, action ) {
    let numberOfDiplomas = diplomas.length;
    let currentOrder = action.item.order;
    let updatedDiplomas;

    switch ( action.type ) {
        case diplomasActionTypes.ADD_DIPLOMA:
            updatedDiplomas = [
                ...diplomas, {
                    ...action.item,
                    order: numberOfDiplomas++,
                }
            ];
            break;

        case diplomasActionTypes.REMOVE_DIPLOMA:
            updatedDiplomas = diplomas
                .filter( diploma => diploma.order !== action.item.order )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( diploma, index ) => {
                    diploma.order = index;
                    return diploma;
                } );
            break;

        case diplomasActionTypes.CHANGE_DIPLOMA:
            updatedDiplomas = diplomas
                .map( diploma => {
                        if ( diploma.order === action.item.order ) {
                            return action.item
                        } else {
                            return diploma
                        }
                    }
                )
            break;

        case diplomasActionTypes.MOVE_DIPLOMA_UP:
            updatedDiplomas = diplomas
                .map( diploma => {
                    if ( diploma.order === action.item.order ) {
                        diploma.order--;
                    } else if ( diploma.order === action.item.order - 1 ) {
                        diploma.order++;
                    }
                    return diploma
                } );
            break;

        case diplomasActionTypes.MOVE_DIPLOMA_DOWN:
            updatedDiplomas = diplomas
                .map( diploma => {
                    if ( diploma.order === currentOrder ) {
                        diploma.order++;
                    } else if ( diploma.order === currentOrder + 1 ) {
                        diploma.order--;
                    }
                    return diploma
                } );
            break;

        default: {
            throw new Error( `Unknown action: [${ action.type }]` );
        }
    }
    return updatedDiplomas.sort( ( a, b ) => a.order - b.order );
}
